import Vue from "vue";
export default {
  GET_FORM(state, payload) {
    state.ffc_form = payload;
  },

  GET_BANNER(state, payload) {
    state.ffc_banner = payload;
  },

  SELECTED_BANNER(state, payload) {
    state.selectedBanner = payload;
  },

  GET_PARTNER(state, payload) {
    state.ffc_partner = payload;
  },

  SELECT_PARTNER(state, payload) {
    state.selectedPartner = payload;
  },

  GET_TESTIMONIAL(state, payload) {
    state.ffc_testimonial = payload;
  },

  GET_ALL_TESTIMONIAL(state, payload) {
    state.ffc_all_testimonial = payload;
  },

  GET_HUB(state, payload) {
    state.ffc_hub = payload;
  },
  SELECTED_HUB(state, payload) {
    state.selectedHub = payload;
  },

  GET_REVIEW(state, payload) {
    state.ffc_review = payload;
  },

  // //////////////////Corporate Events/////////////
  SELECTED_CORPORATE_EVENT(state, payload) {
    state.selected_event = payload;
  },
  setselectservice(state, service) {
    state.selectservice = service;
  },
};
